import i18n from '@/i18n'

/**
 * DB 콘텐츠(스타일/템플릿/카테고리)의 다국어 필드.
 * ko 원문은 name/description 컬럼에, 번역은 nameI18n/descriptionI18n 맵에 저장된다.
 */
export interface LocalizableContent {
  name: string
  description?: string | null
  nameI18n?: Record<string, string> | null
  descriptionI18n?: Record<string, string> | null
}

export function localizeName(item: LocalizableContent, lang: string = i18n.language): string {
  return item.nameI18n?.[lang] ?? item.name
}

export function localizeDescription(
  item: LocalizableContent,
  lang: string = i18n.language,
): string | null | undefined {
  return item.descriptionI18n?.[lang] ?? item.description
}

/**
 * 템플릿 프롬프트의 다국어 필드 (templates 전용).
 * ko 원문은 textPrompt 컬럼에, 번역은 textPromptI18n 맵에 저장된다.
 * ${KEY:-기본값} 파라미터의 KEY 는 언어 무관하게 동일하므로 파라미터 파싱은 그대로 동작한다.
 */
export interface LocalizablePrompt {
  textPrompt: string
  textPromptI18n?: Record<string, string> | null
}

export function localizeTextPrompt(item: LocalizablePrompt, lang: string = i18n.language): string {
  return item.textPromptI18n?.[lang] ?? item.textPrompt
}
